import { render } from "./btn-flow-light-two.vue?vue&type=template&id=54673e39&scoped=true"
import script from "./btn-flow-light-two.vue?vue&type=script&lang=js"
export * from "./btn-flow-light-two.vue?vue&type=script&lang=js"

import "./btn-flow-light-two.vue?vue&type=style&index=0&id=54673e39&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54673e39"

export default script